// Sessão do usuário logado no backoffice admin.
// Guardamos, além do `access_token`, os dados básicos retornados pelo login
// (user_id, email, full_name, is_superuser) para controlar permissões na UI
// sem precisar de requisições adicionais.

const USER_STORAGE_KEY = 'admin_user';

export const setSession = (loginResponse = {}) => {
    const { access_token, ...user } = loginResponse;
    if (access_token) {
        localStorage.setItem('access_token', access_token);
    }
    localStorage.setItem(USER_STORAGE_KEY, JSON.stringify(user));
};

export const getCurrentUser = () => {
    try {
        const raw = localStorage.getItem(USER_STORAGE_KEY);
        return raw ? JSON.parse(raw) : null;
    } catch {
        return null;
    }
};

export const isSuperuser = () => Boolean(getCurrentUser()?.is_superuser);

export const clearSession = () => {
    localStorage.removeItem('access_token');
    localStorage.removeItem(USER_STORAGE_KEY);
};
